import React from 'react'
import Page from 'components/Page/Page'
import Table from 'components/Display/Table/Table'
import {useGetAuditLogQuery, useGetAuditLogsQuery} from 'store/Store'

// Audit logs are append-only — nothing to delete, create or edit from here
const useDisabledDeleteMutation = () => [() => Promise.resolve(), {errorDelete: null}]

const AuditLog = () => {
    return (
        <Page>
            <Table
                itemName="audit_log"
                paginationType="external"
                allowDelete={false}
                allowEdit={false}
                allowExpanded
                useGetQuery={useGetAuditLogsQuery}
                useGetByIdQuery={useGetAuditLogQuery}
                useDeleteMutation={useDisabledDeleteMutation}
            />
        </Page>
    )
}

export default AuditLog
